import React from 'react';
import { ProgressBar } from '../ui-kit';

const PaginatedLoader = ({ percentage, total, loading, estimateLoaded }) => {
  const fullyLoaded = percentage >= 100;
  // no pagination info, and not loading -> render nothing
  if (total === null && !loading) return null;
  if (total === null) {
    // loading without pagination info: show animated bar
    return <ProgressBar now={100} animated={true} className="mb-3" />;
  } else {
    // loading with pagination, show full info
    const label = fullyLoaded ? '' : `${estimateLoaded}/${total}`;
    return <ProgressBar now={percentage} animated={!fullyLoaded} label={label} className="mb-3" />;
  }
};

export default PaginatedLoader;
